<template>
    <div class="mt-1">
        <NuxtLink :to="useLocalePath()('/service/statisticProcessTransfers/' + data.statisticProcessTransferId)">
            <BaseButton
                size="xs"
                @click="emits('close')">
                {{ $t('statisticProcessTransfers.showStatisticProcessTransfer') }}
            </BaseButton>
        </NuxtLink>
    </div>
</template>

<script setup>
const {t: $t} = useI18n()

defineProps({
    data: {
        type: Object,
        required: true
    }
})

const emits = defineEmits(['close'])
</script>